import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import { environmentalChecklistItem } from "../../../../schemas";

export const dayEnvChecklistOfficeSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  officeLocked: environmentalChecklistItem,
  officeComment: z.string().optional(),
});
